import * as S from './style'
import Logo from '../../assets/logoMundial.svg'
import { useForm, SubmitHandler } from "react-hook-form";
import { NavLink, useNavigate } from "react-router-dom";
/**
 * Components
*/
import ActionButton from "../../components/Button/ActionButtonLoad";
/**
 * hooks
*/
import apiRequest from '../../hooks/apiRequest';
import useLoading from "../../hooks/useLoading";
/**
 * Icons 
*/
import { ArrowLeft } from '@phosphor-icons/react';

type Inputs = {
  email: string;
}

export default function ForgotPassword() {

  const {
    register,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest('password/forgot', 'POST', data);
      if (response.status === 200) {
        navigate("/mensagem-sucesso", { state: { email: data.email } });
      }
    } catch (error: any) {
      alert(error.message || error.error || "Ocorreu um erro ao enviar formulário.");
    } finally {
      stopLoading();
    }
  };

  return (
    <S.Container>
      <S.Content>
        <S.ContentImage>
          <S.Image src={Logo} alt="Logo Óticas Mundial" />
        </S.ContentImage>

        <S.Header>
          <S.H3>Esqueceu a Senha?</S.H3>
          <S.TextP>
            Insira o endereço de e-mail da sua conta e enviaremos um e-mail de
            confirmação para redefinir sua senha.
          </S.TextP>
        </S.Header>

        <S.InputForms>
          <S.Label>E-mail *</S.Label>
          <S.Input
            {...register("email", { required: true })}
            type="email"
            placeholder="Informe seu e-mail"
          />
          {errors.email && <S.InforErro>Campo Obrigatório</S.InforErro>}
        </S.InputForms>

        <ActionButton
          type="submit"
          name={isLoading ? "Enviando..." : "Enviar"}
          status={isLoading}
          onClick={handleFormSubmit(onSubmit)}
        />
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <S.Footer>
            <ArrowLeft size={20} />
            <S.ReturnPageLogin>
              Voltar para página de
              <span>Login.</span>
            </S.ReturnPageLogin>
          </S.Footer>
        </NavLink>
      </S.Content>
    </S.Container>
  );
}